export default "__VITE_ASSET__BjFdkppS__"